import ToolTip from 'Generic/ToolTip';
import { Tip } from 'Interfaces/TipInterface';
import React, { useEffect, useState } from 'react';
import './styles.sass';

export interface Props {
    onChange: (val: string) => void;
    onBlur: (event: any) => void;
    id: string;
    label: string;
    name: string;
    isEditing: boolean;
    value: string;
    isRequired: boolean;
    hasError: boolean;
    placeholder?: string;
    errorMessage: string;
    hideLabel: boolean;
    tooltip?: string;
    inputComponent: string;
    globalTxData?: string;
};

/**
 * TODO: Describe this component!
 */
const MvTextOrEdit = ({
    onChange,
    onBlur,
    label,
    id,
    name,
    isEditing,
    placeholder,
    value,
    isRequired,
    hasError,
    errorMessage,
    tooltip,
    hideLabel = false,
    globalTxData,
}: Props) => {
    const [inputValue, setInputValue] = useState<string>(value);

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const handleChange = (e: any) => {
        const selectedValue = e.target.value;
        setInputValue(selectedValue)
        onChange(selectedValue)
    }

    const inputTooltip: [Tip] = [
        {
          label: "",
          desc: tooltip || '',
        },
      ];

    return (
        <div className='mv-text-or-edit'>
            {!hideLabel && <div>
                <label className="input-label" htmlFor={id}>{label}</label>

                {tooltip && <div className='help-tooltip'><ToolTip useRefToPosition={false} tabIndex={0} tip={inputTooltip} id={`mv-textoredit-tooltip-${label}`}>
                    <span className="question-icon">{"?"}</span>
                </ToolTip></div>}
            </div>}
            {isEditing ? <div>
                    <input
                        className={hasError ? 'error' : globalTxData}
                        type='text'
                        placeholder={placeholder}
                        onChange={handleChange}
                        onBlur={onBlur}
                        value={inputValue}
                        id={id}
                        name={name}
                    />
                    {hasError && <div className='mv-input-err-msg'>{errorMessage}</div>}
                </div>
                :
                <p className='input-value'>{value}</p>
            }
            {isRequired && <span className="is-required-ast" />}
        </div>
    );
};

export {
    MvTextOrEdit,
};
